export default __webpack_public_path__ + "static/media/gallery_01.431ec741.jpg";